import React from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import BreadCrumb from "components/common/BreadCrumb";
import { QuotationsTable } from "./QuotationsTable";
import { Link } from "react-router-dom";
import { getDocumentTitle } from "utils/helpers";
import { useAccess } from "features/Authentication/hooks/useAccess";
import { Permissions } from "features/RolesAndPermissions/constants/permission.constants";

const QuotationList = () => {
  document.title = getDocumentTitle("Quotations");
  const { can } = useAccess();
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Quotations" pageTitle="Quotations" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex justify-content-between">
                  <h5 className="card-title mb-0">Quotation List</h5>
                  {can(Permissions.QUOTATION.CREATE) ? (
                    <Link to="/quotations/create" className="btn btn-primary">
                      <i className="ri-add-line align-bottom me-1"></i> Add
                      Quotation
                    </Link>
                  ) : null}
                </CardHeader>
                <CardBody className="pt-0">
                  <QuotationsTable />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default QuotationList;
